var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ApplicationWrapper",
    [
      _c("template", { slot: "header" }, [
        _c(
          "h3",
          {
            style:
              "text-wrap: balance;" + _vm.isMobile()
                ? "text-align: center"
                : "",
          },
          [_vm._v(" " + _vm._s(_vm.$t("common.label_clubNotFound")) + " ")]
        ),
      ]),
      _c(
        "template",
        { slot: "details" },
        [
          _c(
            "v-dialog",
            {
              attrs: { width: "auto", persistent: "", absolute: "absolute" },
              model: {
                value: _vm.showLastClubNumDialog,
                callback: function ($$v) {
                  _vm.showLastClubNumDialog = $$v
                },
                expression: "showLastClubNumDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "text-h5" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("common.label_previousClubFound")) +
                        " "
                    ),
                  ]),
                  _c("v-card-text", [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("common.label_previousClubNumFound", [
                            _vm.lastClubName,
                            _vm.lastClubNum,
                          ])
                        ),
                      },
                    }),
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { loading: _vm.retryButtonLoading },
                          on: {
                            click: function ($event) {
                              _vm.showLastClubNumDialog = false
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("common.label_no")) + " ")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { loading: _vm.retryButtonLoading },
                          on: { click: _vm.handleNavigateToLastClub },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("common.label_yes")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Detail",
            { staticClass: "ma-4", attrs: { containerNoMargin: true } },
            [
              _c(
                "template",
                { slot: "content-override" },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "flex-row",
                      staticStyle: { gap: "32px" },
                      attrs: {
                        "no-gutters": "",
                        justify: "center",
                        align: "center",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-2",
                          staticStyle: { "text-align": "center" },
                        },
                        [
                          _c("v-col", [
                            _vm.clubNumOrigin <= 0
                              ? _c("h4", [
                                  _vm._v(_vm._s(_vm.$t("errors.noClubNum"))),
                                ])
                              : _c("h4", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("errors.clubNumNotFound", [
                                        _vm.clubNumOrigin,
                                      ])
                                    )
                                  ),
                                ]),
                            _c("br"),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("errors.clubNumInfoLine1")) +
                                " "
                            ),
                            _c("br"),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("errors.clubNumInfoLine2")) +
                                " "
                            ),
                          ]),
                          _c(
                            "v-row",
                            {
                              staticStyle: { gap: "16px" },
                              attrs: {
                                "no-gutters": "",
                                align: "center",
                                justify: "center",
                              },
                            },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "3" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "number",
                                      label: _vm.$t("common.label_clubNumber"),
                                      "prepend-icon": "mdi-town-hall",
                                      clearable: "",
                                    },
                                    on: {
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.checkNewClubNum(
                                          _vm.clubNumToRetry
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.clubNumToRetry,
                                      callback: function ($$v) {
                                        _vm.clubNumToRetry = $$v
                                      },
                                      expression: "clubNumToRetry",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "template",
        { slot: "actionbuttons" },
        [
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                loading: _vm.retryButtonLoading,
                disabled:
                  _vm.clubNumToRetry == undefined || _vm.clubNumToRetry <= 0,
              },
              on: {
                click: function ($event) {
                  return _vm.checkNewClubNum(_vm.clubNumToRetry)
                },
              },
            },
            [
              _c("v-icon", [_vm._v(" mdi mdi-reload-alert ")]),
              _vm._v(" " + _vm._s(_vm.$t("common.label_tryAgain")) + " "),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }